import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNavigation = (path: string) => {
    if (path.startsWith('/')) {
      window.REACT_APP_NAVIGATE(path);
    } else {
      const element = document.getElementById(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleSubscribe = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d55s8dfq1d2qkrs09g5g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-blue-900 rounded-t-[32px] mx-10 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <img
              src="/assets/logo.png"
              alt="Ester LifeSciences"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-blue-200 text-sm mb-6 leading-relaxed">
              Pioneering excellence in cardiovascular and diabetic care with quality pharmaceutical solutions.
            </p>
            {/* <form onSubmit={handleSubscribe} className="mb-4" data-readdy-form id="newsletter-form">
              <h4 className="text-white font-semibold mb-3">Subscribe to Updates</h4>
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-4 py-2 bg-transparent border-b-2 border-blue-300 text-white placeholder-blue-300 outline-none focus:border-white transition-colors text-sm"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-transparent border-2 border-white text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-white hover:text-blue-900 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {isSubmitting ? '...' : 'Subscribe →'}
                </button>
              </div>
              {submitStatus === 'success' && (
                <p className="text-green-300 text-xs mt-2">Subscribed successfully!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-300 text-xs mt-2">Error. Please try again.</p>
              )}
            </form> */}
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-blue-200">
              <li>
                <Link to="/" className="hover:text-teal-400 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-teal-400 transition-colors cursor-pointer">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-teal-400 transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/culture" className="hover:text-teal-400 transition-colors cursor-pointer">
                  Work Culture
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-teal-400 transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Products</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                  Cholesterol Management
                </a>
              </li>
              <li>
                <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                  Hypertension Control
                </a>
              </li>
              <li>
                <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                  Antiplatelet Therapy
                </a>
              </li>
              <li>
                <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                  Beta Blockers
                </a>
              </li>
              <li>
                <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                  Anticoagulants
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Compliance</h4>
            <ul className="space-y-3">
              <li className="text-blue-200 text-sm">ISO 9001:2015 Certified</li>
              <li className="text-blue-200 text-sm">WHO-GMP Compliant</li>
              <li className="text-blue-200 text-sm">Quality Assurance</li>
              <li className="text-blue-200 text-sm">Regulatory Affairs</li>
              <li className="text-blue-200 text-sm">Product Sourcing</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            {/* <div className="flex gap-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white transition-colors text-sm underline"
              >
                LinkedIn
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white transition-colors text-sm underline"
              >
                Twitter
              </a>
              <a
                href="mailto:info@estaerlifesciences.com"
                className="text-blue-200 hover:text-white transition-colors text-sm underline"
              >
                Email
              </a>
            </div> */}

            <div className="text-blue-200 text-sm text-center">
              © 2025 Ester LifeSciences. All rights reserved.
            </div>

            {/* <div className="flex gap-6">
              <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                Privacy Policy
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors text-sm underline">
                Terms of Use
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white transition-colors text-sm underline"
              >
                Website Builder
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
